import { Component, ViewChild, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';
import { ConsuntivatoreDubaiService } from '../services/consuntivatoredubai/consuntivatore-dubai.service';
import { AuthService } from '../auth/auth.service';
import { forkJoin, Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, switchMap } from 'rxjs/operators';
import { ConfirmDialogComponent } from './dialog/confirm-dialog.component'; // Assicurati del percorso corretto
import { MatDialog } from '@angular/material/dialog';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { UserSessionService } from '../services/user-session.service';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

interface TeamLeader {
    Id: number;
    name: string;
    CodiceFiscale: string;
    projects: Project[];
}

interface Project {
    id: number;
    code: string;
    nameBuilding: string;
    nameSubject: string;  // ✅ Aggiunto campo per il nome della commessa
}


@Component({
    selector: 'app-consuntivatore-dubai',
    templateUrl: './consuntivatore-dubai.component.html',
    styleUrls: ['./consuntivatore-dubai.component.scss']
})
export class ConsuntivatoreDubaiComponent implements OnInit, AfterViewInit {
    constructor(private toastr: ToastrService, private consDubaiService: ConsuntivatoreDubaiService, public authService: AuthService, private cdr: ChangeDetectorRef,
        public dialog: MatDialog, private scrollStrategies: ScrollStrategyOptions, private userSessionService: UserSessionService, private translate: TranslateService

    ) { }

    searchTeamLeader: string = '';

    pageSizeLeaders = 10;
    pageIndexLeaders = 0;
    totalLeaders = 0; // Totale per i capi squadra

    pageSizeProjects = 15;
    pageIndexProjects = 0;
    totalProjects = 0; // Totale per le commesse

    hasChanges = false; // Variabile per abilitare/disabilitare il pulsante save

    teamLeaders: TeamLeader[] = [];

    projects: Project[] = [];

    searchProject: string = '';
    searchProjectSubject = new Subject<any>(); // 🔍 Subject per la ricerca
    loading: boolean = true; // 🔥 Variabile di stato per il caricamento
    isLoadingProjects: boolean = false;
    private sub: Subscription;
    idSede: string = '';
    nameSede: string = '';
    country: string = '';
    // invalidCompanySelected = false;

    @ViewChild('projectList') projectListDropList: any;
    private dropInProgress = new Set<number>(); // id delle commesse in gestione
    private lastSearchFilters = {
        selectedCountry: '',
        selectedSocieta: '',
        selectedSedi: ''
    };

    @ViewChild('paginatorLeaders') paginatorLeaders!: MatPaginator;
    @ViewChild('paginatorProjects') paginatorProjects!: MatPaginator;
    operatorSearchTerm: string = '';
    selectedOperators: any[] = [];
    availableOperators: any[] = [];
    operatorsControl = new FormControl([]);
    operatorsSearchControl = new FormControl('');
    filteredOperators: any[] = []; // da usare nel template

    countryList: any[] = [];
    societaList: any[] = [];
    sediList: any[] = [];

    selectedCountries: any;  // Kendo MultiSelect vuole array, anche se single select!
    selectedSocieta: any;
    selectedSedi: string[] = [];


    loadingCountry = false;
    loadingSocieta = false;
    loadingSedi = false;

    societaFilter: string = '';
    sediFilter: string = '';
    filteredSocietaList: any[] = [];
    filteredSediList: any[] = [];


    onOperatorFilterChange(searchTerm: string): void {
        const term = searchTerm.toLowerCase();
        this.filteredOperators = this.availableOperators.filter(op =>
            op.name.toLowerCase().includes(term) ||
            op.ruolo?.toLowerCase().includes(term)
        );
    }
    isSearchEnabled(): boolean {
        return (
            (this.selectedCountries && this.selectedCountries?.length > 0) ||
            (this.selectedSocieta && this.selectedSocieta?.length > 0) ||
            (this.selectedSedi && this.selectedSedi?.length > 0)
        );
    }

    onSocietaFilterChange(searchTerm: string): void {
        const term = (searchTerm || '').toLowerCase();
        this.filteredSocietaList = this.societaList.filter(soc =>
            soc.DESCRIZIONE.toLowerCase().includes(term)
        );
    }

    onSediFilterChange(searchTerm: string): void {
        const term = (searchTerm || '').toLowerCase();
        this.filteredSediList = this.sediList.filter(sede =>
            sede.NomeSede.toLowerCase().includes(term)
        );
    }

    // Funzione per caricare società e sedi senza filtri (all’avvio)
    loadSocietaAndSedi() {
        this.loadingSocieta = true;
        this.consDubaiService.getSocieta(this.authService.idToken(), this.authService.user().email)
            .subscribe(res => {
                this.societaList = res.item?.Table || [];
                this.filteredSocietaList = [...this.societaList]; // 👈 AGGIUNTO
                this.loadingSocieta = false;
            }, err => {
                this.societaList = [];
                this.loadingSocieta = false;
            });

        this.loadingSedi = true;
        this.consDubaiService.getSedi(this.authService.idToken(), this.authService.user().email)
            .subscribe(res => {
                this.sediList = res.item?.Table || [];
                this.filteredSediList = [...this.sediList]; // 👈 AGGIUNTO
                this.loadingSedi = false;
            }, err => {
                this.sediList = [];
                this.loadingSedi = false;
            });
    }
    onCountryChange() {
        const selectedCountry = this.selectedCountries.length > 0
            ? this.selectedCountries.map((c: any) => c.Country).join(',')
            : null;

        const selectedSocieta: string | undefined = this.selectedSocieta?.length > 0
            ? this.selectedSocieta.map((s: any) => s.ID || s).join(',')
            : undefined;

        console.log('selectedCountry: ', selectedCountry)

        if (!selectedCountry) {
            this.loadSocietaAndSedi();
            return;
        }

        // Carica società per country
        this.loadingSocieta = true;
        this.consDubaiService.getSocieta(
            this.authService.idToken(),
            this.authService.user().email,
            selectedCountry
        ).subscribe(res => {
            this.societaList = res.item?.Table || [];
            this.filteredSocietaList = [...this.societaList];
            this.loadingSocieta = false;

            // 🔥 Dopo il caricamento, aggiorna selectedSocieta
            const validSocietaIds = this.societaList.map(s => s.ID);
            this.selectedSocieta = (this.selectedSocieta || []).filter((s: any) => validSocietaIds.includes(s.ID || s));

        }, err => {
            this.societaList = [];
            this.filteredSocietaList = [];
            this.selectedSocieta = [];
            this.loadingSocieta = false;
        });

        // Carica sedi per country
        this.loadingSedi = true;
        this.consDubaiService.getSedi(
            this.authService.idToken(),
            this.authService.user().email,
            selectedCountry,
            selectedSocieta
        ).subscribe(res => {
            this.sediList = res.item?.Table || [];
            this.filteredSediList = [...this.sediList];
            this.loadingSedi = false;

            // 🔥 Dopo il caricamento, aggiorna selectedSedi
            const validSediIds = this.sediList.map(s => s.IdSede);
            this.selectedSedi = (this.selectedSedi || []).filter((s: any) => validSediIds.includes(s.IdSede || s));
        }, err => {
            this.sediList = [];
            this.filteredSediList = [];
            this.selectedSedi = [];
            this.loadingSedi = false;
        });
    }



    onSocietaChange() {
        const selectedCountry: string | undefined = this.selectedCountries?.length > 0
            ? this.selectedCountries.map((c: any) => c.Country || c).join(',')
            : undefined;

        const selectedSocieta: string | undefined = this.selectedSocieta?.length > 0
            ? this.selectedSocieta.map((s: any) => s.ID || s).join(',')
            : undefined;

        // Reset sedi selezionate
        // this.selectedSedi = [];
        // this.sediList = [];

        if (!selectedSocieta) {
            // Se deselezioni tutte le società, ricarica sedi solo per country
            this.onCountryChange();
            return;
        }

        // Carica sedi filtrando per country e per tutte le società selezionate
        this.loadingSedi = true;
        this.consDubaiService.getSedi(
            this.authService.idToken(),
            this.authService.user().email,
            selectedCountry,
            selectedSocieta
        ).subscribe(res => {
            this.sediList = res.item?.Table || [];
            this.filteredSediList = [...this.sediList];
            this.loadingSedi = false;

            // 🔥 Dopo il caricamento, aggiorna selectedSedi
            const validSediIds = this.sediList.map(s => s.IdSede);
            this.selectedSedi = (this.selectedSedi || []).filter((s: any) => validSediIds.includes(s.IdSede || s));

        }, err => {
            this.sediList = [];
            this.filteredSediList = [];
            this.selectedSedi = [];
            this.loadingSedi = false;
        });
    }




    ngOnInit(): void {
        // 1. Carica i Paesi disponibili
        this.loadingCountry = true;
        this.consDubaiService.getCountry(this.authService.idToken(), this.authService.user().email)
            .subscribe(res => {
                this.countryList = res.item?.Table || [];
                this.loadingCountry = false;
            }, err => {
                this.countryList = [];
                this.loadingCountry = false;
            });

        // 2. Carica società e sedi SENZA filtri
        this.loadSocietaAndSedi();

        // 3. Setta i dati della compagnia (ma NON li usiamo all'inizio per caricare dati!)
        // const company = this.userSessionService.getState('working_company');
        // console.log('company scelta?: ', company);

        // this.idSede = company?.id || '';
        // this.nameSede = company?.name || '';
        // this.country = company?.country || '';

        // this.sub = this.userSessionService.$changeCompanyDetector.subscribe(() => {
        //     window.location.reload();
        // });

        // 4. Avvia il caricamento iniziale senza filtri
        this.loading = true;

        this.loadData().then(() => {
            // Dopo aver caricato operatori e commesse, carico anche le assegnazioni
            this.consDubaiService.getCommesseConsuntivazioneDubai(
                this.authService.idToken(),
                this.authService.user().email
            ).subscribe(response => {
                console.log('🗄️ Relazioni iniziali dal DB:', response);

                if (response.esito === "OK" && response.item && response.item.Table) {
                    this.initializeDragDropAssignments(response.item.Table);
                }

                this.loading = false;
                this.cdr.detectChanges();
            }, error => {
                console.error('❌ Errore nel recupero delle commesse assegnate:', error);
                this.loading = false;
            });
        });

        // 5. Gestione della ricerca dinamica delle commesse
        this.searchProjectSubject.pipe(
            debounceTime(400),
            distinctUntilChanged((prev, curr) =>
                prev.searchTerm === curr.searchTerm &&
                prev.selectedCountry === curr.selectedCountry &&
                prev.selectedSocieta === curr.selectedSocieta &&
                prev.selectedSedi === curr.selectedSedi
            ),
            switchMap(({ searchTerm, selectedCountry, selectedSocieta, selectedSedi }) => {
                this.isLoadingProjects = true;

                return this.consDubaiService.getConsuntivazioneDubai(
                    this.authService.idToken(),
                    this.authService.user().email,
                    searchTerm,
                    selectedCountry,
                    selectedSocieta,
                    selectedSedi,
                );
            })
        ).subscribe(res => {
            this.projects = res.item?.Table || [];
            this.totalProjects = this.projects.length;

            if (this.paginatorProjects) {
                this.paginatorProjects.firstPage();
            }

            this.isLoadingProjects = false;
            this.cdr.detectChanges();
        }, error => {
            console.error('❌ Errore nella ricerca delle commesse:', error);
            this.isLoadingProjects = false;
        });

        // 6. Gestione della ricerca dinamica degli operatori
        this.operatorsSearchControl.valueChanges
            .pipe(startWith(''))
            .subscribe(searchTerm => {
                const term = searchTerm?.toLowerCase() || '';
                this.filteredOperators = this.availableOperators.filter(op =>
                    op.name.toLowerCase().includes(term)
                );
            });
    }

    async loadData(): Promise<void> {
        await Promise.all([
            new Promise<void>((resolve) => {
                this.consDubaiService.getOperators(
                    this.authService.idToken(),        // userToken
                    this.authService.user().email,     // email
                    '',                                // country vuoto
                    ['35', '36', '124'],                      // idProfilo obbligatorio
                    '',                                // idSedi vuoto
                    ''                                 // idSocieta vuoto
                ).subscribe(res => {
                    let operators = res.item?.Table || [];

                    // 🔥 Raggruppa per ID
                    const operatorsGroupedById = operators.reduce((acc: { [x: string]: any[]; }, op: { id: string | number; }) => {
                        if (!acc[op.id]) {
                            acc[op.id] = [];
                        }
                        acc[op.id].push(op);
                        return acc;
                    }, {} as { [key: number]: any[] });

                    // 🔥 Per ogni gruppo scegli: prima "Capo Squadra", se non c'è allora il primo
                    const uniqueOperators = Object.values(operatorsGroupedById).map((group: any) => {
                        const capoSquadra = group.find((op: { ruolo: string; }) => op.ruolo === 'Operaio Capo Squadra');
                        return capoSquadra || group[0];
                    });

                    this.availableOperators = uniqueOperators;
                    this.filteredOperators = [...uniqueOperators];
                    this.teamLeaders = uniqueOperators.map((leader: any) => ({
                        ...leader,
                        Id: leader.id,
                        projects: []
                    }));

                    resolve();
                });
            }),
            new Promise<void>((resolve) => {
                this.consDubaiService.getConsuntivazioneDubai(
                    this.authService.idToken(),
                    this.authService.user().email,
                    '' // idSede VUOTO qui
                ).subscribe(res => {
                    this.projects = res.item?.Table || [];
                    resolve();
                });
            })
        ]);
    }



    ngAfterViewInit() {

        this.updatePagination();
    }
    onSearchFilters() {
        const selectedCountry = this.selectedCountries?.length > 0
            ? this.selectedCountries.map((c: any) => c.Country || c).join(',')
            : '';

        const selectedSocieta = this.selectedSocieta?.length > 0
            ? this.selectedSocieta.map((s: any) => s.ID || s).join(',')
            : '';

        const selectedSedi = this.selectedSedi?.length > 0
            ? this.selectedSedi.map((s: any) => s.IdSede || s).join(',')
            : '';

        this.loading = true;

        // 🔥 1. Carico operatori
        this.consDubaiService.getOperators(
            this.authService.idToken(),
            this.authService.user().email,
            selectedCountry,
            ['35', '36', '124'],
            selectedSedi,
            selectedSocieta,
        ).subscribe(res => {
            const operators = res.item.Table || [];

            // Raggruppa per ID
            const operatorsGroupedById = operators.reduce((acc: { [key: number]: any[] }, op: any) => {
                if (!acc[op.id]) acc[op.id] = [];
                acc[op.id].push(op);
                return acc;
            }, {});

            // Scegli il capo squadra se esiste, altrimenti il primo
            const uniqueOperators = Object.values(operatorsGroupedById).map((group: any) => {
                const capo = group.find((op: any) => op.ruolo === 'Operaio Capo Squadra');
                return capo || group[0];
            });

            this.availableOperators = uniqueOperators;
            this.filteredOperators = [...uniqueOperators];
            this.teamLeaders = uniqueOperators.map((leader: any) => ({
                ...leader,
                Id: leader.id,
                projects: []
            }));


            // 🔥 2. Dopo aver caricato operatori, carico commesse assegnate
            this.consDubaiService.getCommesseConsuntivazioneDubai(
                this.authService.idToken(),
                this.authService.user().email,
            ).subscribe(response => {
                console.log('🗄️ Relazioni aggiornate dal DB:', response);

                if (response.esito === "OK" && response.item && response.item.Table) {
                    this.initializeDragDropAssignments(response.item.Table);
                }

                this.loading = false;
                this.cdr.detectChanges();
            }, error => {
                console.error('❌ Errore nel recupero delle assegnazioni:', error);
                this.loading = false;
            });

        }, err => {
            this.availableOperators = [];
            this.filteredOperators = [];
            this.teamLeaders = [];
            this.loading = false;
        });

        // 🔥 3. Intanto carico anche le nuove commesse filtrate (lista generale delle commesse)
        this.isLoadingProjects = true;
        this.consDubaiService.getConsuntivazioneDubai(
            this.authService.idToken(),
            this.authService.user().email,
            '',
            selectedCountry,
            selectedSocieta,
            selectedSedi
        ).subscribe(res => {
            this.projects = res.item.Table || [];
            this.isLoadingProjects = false;
            this.cdr.detectChanges();
        }, err => {
            this.projects = [];
            this.isLoadingProjects = false;
        });
        this.lastSearchFilters = {
            selectedCountry,
            selectedSocieta,
            selectedSedi
        };
        this.searchProject = ''; // reset campo ricerca
        this.searchTeamLeader = '';    // reset filtro capi squadra
        this.paginatorProjects?.firstPage(); // reset paginatore
        this.searchProjectSubject.next({
            searchTerm: '',
            ...this.lastSearchFilters
        });
    }

    // onSearchFilters() {
    //     const selectedCountry = this.selectedCountries?.length > 0
    //         ? this.selectedCountries.map((c: any) => c.Country || c).join(',')
    //         : '';

    //     const selectedSocieta = this.selectedSocieta?.length > 0
    //         ? this.selectedSocieta.map((s: any) => s.ID || s).join(',')
    //         : '';

    //     const selectedSedi = this.selectedSedi?.length > 0
    //         ? this.selectedSedi.map((s: any) => s.IdSede || s).join(',')
    //         : '';

    //     this.loading = true;

    //     this.consDubaiService.getOperators(
    //         this.authService.idToken(),
    //         this.authService.user().email,
    //         selectedCountry,
    //         ['35', '36'],
    //         selectedSedi,
    //         selectedSocieta,
    //     ).subscribe(res => {
    //         this.availableOperators = res.item.Table || [];
    //         this.filteredOperators = [...this.availableOperators];
    //         this.teamLeaders = res.item.Table.map((leader: any) => ({
    //             ...leader,
    //             Id: leader.id,
    //             projects: []
    //         }));
    //         this.loading = false;
    //         this.cdr.detectChanges();
    //     }, err => {
    //         this.availableOperators = [];
    //         this.filteredOperators = [];
    //         this.teamLeaders = [];
    //         this.loading = false;
    //     });

    //     this.isLoadingProjects = true;
    //     this.consDubaiService.getConsuntivazioneDubai(
    //         this.authService.idToken(),
    //         this.authService.user().email,
    //         '',
    //         selectedCountry,
    //         selectedSocieta,
    //         selectedSedi
    //     ).subscribe(res => {
    //             this.projects = res.item.Table || [];
    //             this.isLoadingProjects = false;
    //             this.cdr.detectChanges();
    //         }, err => {
    //             this.projects = [];
    //             this.isLoadingProjects = false;
    //         });
    // }


    onResetFilters() {
        // Azzera i filtri
        this.selectedCountries = [];
        this.selectedSocieta = [];
        this.selectedSedi = [];

        // Ricarica tutte le società e sedi SENZA filtri
        this.loadSocietaAndSedi();

        // Ricarica dati senza filtri (come all’avvio)
        this.loading = true;
        this.isLoadingProjects = true;

        this.consDubaiService.getOperators(
            this.authService.idToken(),
            this.authService.user().email,
            '', // country vuoto
            ['35', '36', '124'],
            '', // società vuota
            ''  // sede vuota
        ).subscribe(res => {
            this.availableOperators = res.item.Table || [];
            this.filteredOperators = [...this.availableOperators];
            this.teamLeaders = res.item.Table.map((leader: any) => ({
                ...leader,
                Id: leader.id,
                projects: []
            }));
            this.loading = false;
            this.cdr.detectChanges();
        }, err => {
            this.availableOperators = [];
            this.filteredOperators = [];
            this.teamLeaders = [];
            this.loading = false;
        });

        this.consDubaiService.getConsuntivazioneDubai(
            this.authService.idToken(),
            this.authService.user().email,
            ''
        ).subscribe(res => {
            this.projects = res.item.Table || [];
            this.isLoadingProjects = false;
            this.cdr.detectChanges();
        }, err => {
            this.projects = [];
            this.isLoadingProjects = false;
        });
    }

    updatePaginationProjects(event: any) {
        this.pageSizeProjects = event.pageSize;
        this.pageIndexProjects = event.pageIndex;
        this.cdr.detectChanges();
    }

    updatePaginationLeaders(event: any) {
        this.pageSizeLeaders = event.pageSize;
        this.pageIndexLeaders = event.pageIndex;
        this.cdr.detectChanges();
    }


    initializeDragDropAssignments(assignments: { WorkerId: number, Pratica: string }[]): void {
        assignments.forEach(assignment => {
            const teamLeader = this.teamLeaders.find(tl => tl.Id === assignment.WorkerId);

            if (teamLeader) {
                const practiceIds = assignment.Pratica
                    .split(',')
                    .map(p => Number(p.trim()))
                    .filter(p => !isNaN(p));

                practiceIds.forEach(practiceId => {
                    const project = this.projects.find(p => p.id === practiceId);
                    if (project) {
                        const alreadyAssigned = teamLeader.projects.some(p => p.id === project.id);
                        if (!alreadyAssigned) {
                            teamLeader.projects.push({ ...project });
                        }
                    }
                });

                console.log(`🔗 Assegno ${teamLeader.projects.length} commesse a ${teamLeader.name}`, teamLeader.projects);
            }
        });

        this.cdr.detectChanges();
    }






    updatePagination() {
        this.pageIndexLeaders = this.paginatorLeaders?.pageIndex || 0;
        this.pageSizeLeaders = this.paginatorLeaders?.pageSize || 10;

        this.pageIndexProjects = this.paginatorProjects?.pageIndex || 0;
        this.pageSizeProjects = this.paginatorProjects?.pageSize || 15;
    }
    getCommesseObservable(): Observable<any> {
        return this.consDubaiService.getConsuntivazioneDubai(this.authService.idToken(), this.authService.user().email, this.idSede);
    }

    onSearchChange(searchValue: string) {
        this.searchProjectSubject.next({
            searchTerm: searchValue,
            ...this.lastSearchFilters
        });
    }




    getCommesse() {
        this.consDubaiService.getConsuntivazioneDubai(this.authService.idToken(), this.authService.user().email, this.idSede).subscribe(res => this.projects = res.item.Table)
    }


    get filteredTeamLeaders(): TeamLeader[] {
        const searchTerm = (this.searchTeamLeader || '').trim().toLowerCase();

        let filtered: TeamLeader[];

        if (!searchTerm) {
            filtered = [...this.teamLeaders];
        } else {
            filtered = this.teamLeaders.filter(leader => {
                const matchName = leader.name.toLowerCase().includes(searchTerm);
                const matchCodiceFiscale = leader.CodiceFiscale?.toLowerCase().includes(searchTerm);

                const matchProject = leader.projects.some(project =>
                    (project.code && project.code.toLowerCase().includes(searchTerm)) ||
                    (project.nameBuilding && project.nameBuilding.toLowerCase().includes(searchTerm)) ||
                    (project.nameSubject && project.nameSubject.toLowerCase().includes(searchTerm))
                );

                return matchName || matchCodiceFiscale || matchProject;
            });
        }

        this.totalLeaders = filtered.length;

        if (this.paginatorLeaders) {
            this.paginatorLeaders.length = this.totalLeaders;
            const maxPageIndex = Math.floor(this.totalLeaders / this.pageSizeLeaders);
            if (this.paginatorLeaders.pageIndex > maxPageIndex) {
                this.paginatorLeaders.firstPage();
            }
            this.pageIndexProjects = this.paginatorProjects.pageIndex;
        }

        return filtered.slice(
            (this.paginatorLeaders?.pageIndex || 0) * this.pageSizeLeaders,
            ((this.paginatorLeaders?.pageIndex || 0) + 1) * this.pageSizeLeaders
        );
    }




    get filteredProjects(): Project[] {
        let filtered;
        if (this.searchProject.trim() !== '') {
            // 🔍 Se la ricerca è attiva, usa direttamente i dati aggiornati dalla chiamata API
            // return this.projects.slice(this.pageIndexProjects * this.pageSizeProjects, (this.pageIndexProjects + 1) * this.pageSizeProjects);
            filtered = [...this.projects];

        } else {
            // 🔹 Se non c'è ricerca attiva, applica il filtro locale sui dati completi
            filtered = this.projects.filter(project =>
                project.code.toLowerCase().includes(this.searchProject.toLowerCase()) ||
                project.nameBuilding.toLowerCase().includes(this.searchProject.toLowerCase())
            );
        }

        this.totalProjects = filtered.length; // ✅ Aggiorna il numero totale delle commesse

        // ✅ Se il paginator è inizializzato, aggiorna la paginazione
        if (this.paginatorProjects) {
            this.paginatorProjects.length = this.totalProjects;

            // 🔥 Se la pagina corrente è oltre il massimo, torna alla prima pagina
            const maxPageIndex = Math.floor(this.totalProjects / this.pageSizeProjects);
            if (this.paginatorProjects.pageIndex > maxPageIndex) {
                this.paginatorProjects.firstPage();
            }

            this.pageIndexProjects = this.paginatorProjects.pageIndex; // 🔥 Aggiorna il valore
        }

        // ✅ Paginazione sui risultati filtrati
        return filtered.slice(
            (this.pageIndexProjects || 0) * this.pageSizeProjects,
            ((this.pageIndexProjects || 0) + 1) * this.pageSizeProjects
        );
    }

    get connectedLists(): string[] {
        return this.filteredTeamLeaders
            .map(tl => tl.Id ? `leader-${tl.Id}` : '')
            .filter(id => id !== ''); // ✅ Esclude ID errati
    }

    // drop(event: CdkDragDrop<Project[]>, newTeamLeader?: TeamLeader) {
    //     if (!event.previousContainer || !event.container || !newTeamLeader) return;

    //     const draggedProject: Project = event.previousContainer.data[event.previousIndex];

    //     // Verifica se il progetto è già assegnato a questo team leader
    //     const alreadyAssigned = newTeamLeader.projects.some(p => p.id === draggedProject.id);
    //     if (alreadyAssigned) {
    //         console.warn(`⚠️ La commessa ${draggedProject.id} è già assegnata a ${newTeamLeader.name}`);
    //         this.toastr.info('Questa commessa è già assegnata a questo capo cantiere.');
    //         return;
    //     }

    //     // Esegui l'assegnazione al nuovo team leader
    //     this.addProjectToNewTeamLeader(newTeamLeader, draggedProject);
    // }
    drop(event: CdkDragDrop<Project[]>, newTeamLeader?: TeamLeader) {
        if (!event.previousContainer || !event.container || !newTeamLeader) return;

        const draggedProject: Project = event.previousContainer.data[event.previousIndex];
        const sourceId = event.previousContainer.id;
        const targetId = event.container.id;

        console.log('🔽 Drop source ID:', sourceId);
        console.log('🔼 Drop target ID:', targetId);

        const isFromProjectList = sourceId === 'projectList';

        // ✅ Evita operazioni concorrenti sulla stessa commessa
        if (this.dropInProgress.has(draggedProject.id)) {
            console.warn(`⏳ Operazione già in corso per la commessa ${draggedProject.id}`);
            return;
        }
        this.dropInProgress.add(draggedProject.id);

        // ❌ Evita assegnazioni duplicate
        if (newTeamLeader.projects.some(p => p.id === draggedProject.id)) {
            this.toastr.info(
                this.translate.instant('CONS_DUBAI.PROJECT_ALREADY_ASSIGNED', { name: newTeamLeader.name })
            );
            this.dropInProgress.delete(draggedProject.id);
            return;
        }

        // 🔁 Se proviene da un altro team leader (e non dalla projectList)
        if (!isFromProjectList) {
            const match = sourceId.match(/^leader-(\d+)$/);
            const previousLeaderId = match ? +match[1] : null;

            const previousTeamLeader = this.teamLeaders.find(tl => tl.Id === previousLeaderId);

            if (previousTeamLeader) {
                console.warn(`[🧠 LOG] Trasferimento commessa ${draggedProject.id} da ${previousTeamLeader.name} a ${newTeamLeader.name}`);

                this.consDubaiService.deleteConsuntivazioneDubaiAssociazionePraticaOperatore(
                    this.authService.idToken(),
                    this.authService.user().email,
                    draggedProject.id,
                    previousTeamLeader.Id
                ).subscribe({
                    next: () => {
                        previousTeamLeader.projects = previousTeamLeader.projects.filter(p => p.id !== draggedProject.id);
                        this.cdr.detectChanges();

                        this.addProjectToNewTeamLeader(newTeamLeader, draggedProject);
                        this.dropInProgress.delete(draggedProject.id);
                    },
                    error: (err) => {
                        console.error('❌ Errore nella rimozione della commessa:', err);
                        this.dropInProgress.delete(draggedProject.id);
                    }
                });

                return;
            } else {
                console.log(`ℹ️ Nessun leader trovato da cui rimuovere la commessa ${draggedProject.id}`);
            }
        }

        // ✅ Se arriva dalla lista generale o non c’è leader da cui rimuoverla
        this.addProjectToNewTeamLeader(newTeamLeader, draggedProject);
        this.dropInProgress.delete(draggedProject.id);
    }







    /** ✅ Funzione per assegnare la pratica al nuovo capo squadra */
    addProjectToNewTeamLeader(newTeamLeader: TeamLeader, project: Project) {
        console.log(`➕ Aggiungo la pratica ${project.id} a ${newTeamLeader.name}`);
        const alreadyAssigned = newTeamLeader.projects.some(p => p.id === project.id);
        if (alreadyAssigned) {
            console.warn(`⚠️ La commessa ${project.id} è già assegnata a ${newTeamLeader.name}`);
            return; // ✅ evita duplicati nello stesso leader
        }
        this.consDubaiService.setConsuntivazioneDubaiAssociazionePraticaOperatore(
            this.authService.idToken(),
            this.authService.user().email,
            [{ practiceId: project.id, WorkerId: newTeamLeader.Id }]
        ).subscribe({
            next: (response) => {
                if (response?.esito === 'OK') {
                    console.log(`✅ Pratica ${project.id} assegnata con successo a ${newTeamLeader.name}`, response);
                    this.toastr.success(
                        this.translate.instant('CONS_DUBAI.TOAST_SAVE_SUCCESS')
                    );
                    newTeamLeader.projects.push({ ...project }); // ✅ clone per sicurezza
                    this.cdr.detectChanges();
                } else {
                    const msg = response?.item?.error || 'Errore sconosciuto';
                    console.error(`❌ Errore logico durante l’assegnazione della pratica ${project.id}:`, response);
                    this.toastr.error(
                        this.translate.instant('CONS_DUBAI.TOAST_ERROR_TITLE')
                            `Errore durante l’assegnazione: ${msg}`,
                    );

                }
            },
            error: (error) => {
                console.error('❌ Errore HTTP:', error);
                this.toastr.error('Errore di comunicazione con il server', 'Errore');
            }
        });
    }


    removeProject(teamLeader: TeamLeader, project: Project) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: { message: this.translate.instant('CONS_DUBAI.CONFIRM_DELETE_MESSAGE') },
            scrollStrategy: this.scrollStrategies.reposition() // ✅ Usa ScrollStrategyOptions
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log(`🗑️ Eliminazione della pratica ${project.id} dal capo squadra ${teamLeader.Id}`);

                this.consDubaiService.deleteConsuntivazioneDubaiAssociazionePraticaOperatore(
                    this.authService.idToken(),
                    this.authService.user().email,
                    project.id,
                    teamLeader.Id
                ).subscribe(response => {
                    if (response?.esito === 'OK') {
                        this.toastr.success(
                            this.translate.instant('CONS_DUBAI.REMOVE_ASSIGNMENT_SUCCESS')
                        );
                        teamLeader.projects = teamLeader.projects.filter(p => p.id !== project.id);
                        this.hasChanges = true;
                    } else {
                        const msg = response?.item?.error || 'Errore sconosciuto';
                        this.toastr.error(
                            this.translate.instant('CONS_DUBAI.TOAST_ERROR_TITLE'),
                            `Errore nella rimozione: ${msg}`
                        );

                        console.error('❌ Errore logico (esito KO):', response);
                    }
                }, error => {
                    console.error('❌ Errore HTTP:', error);
                    this.toastr.error('Errore di comunicazione con il server', 'Errore');
                });
            }
        });
    }

    sanitizeValue(value: any, fallback: string = 'N/D'): string {
        return (value === null || value === undefined || value.trim() === '') ? fallback : value;
    }

    submitAssignments() {
        this.toastr.success(
            this.translate.instant('CONS_DUBAI.TOAST_SAVE_SUCCESS'),
        );
        this.hasChanges = false; // ✅ Dopo il salvataggio, il pulsante viene disabilitato
    }

    showResponsePopup(response: any, successMessage: string, errorMessage: string): boolean {
        if (response?.esito === 'OK') {
            this.toastr.success(
                this.translate.instant('CONS_DUBAI.TOAST_SUCCESS_TITLE'),
                successMessage,
            );
            return true;
        } else {
            const errorDetail = response?.item?.error || 'Errore generico.';
            this.toastr.error(
                this.translate.instant('CONS_DUBAI.TOAST_ERROR_TITLE'),
                `${errorMessage}\n${errorDetail}`
            );

            return false;
        }
    }

    getTranslatedRole(ruolo: string): string {
        switch (ruolo) {
            case 'Operaio Capo Squadra':
                return 'ROLE_TEAM_LEADER';
            case 'Operaio Assistente':
                return 'ROLE_ASSISTANT';
            default:
                return ruolo; // fallback se arriva qualcosa di imprevisto
        }
    }

    assignOperatorsToProject(project: Project): void {
        if (!this.selectedOperators || this.selectedOperators.length === 0) return;

        const filteredOperators = this.selectedOperators.filter(op => {
            const teamLeader = this.teamLeaders.find(tl => tl.Id === op.id);
            const alreadyAssigned = teamLeader?.projects.some(p => p.id === project.id);
            if (alreadyAssigned) {
                console.warn(`⚠️ La commessa ${project.id} è già assegnata a ${teamLeader?.name}`);
                this.toastr.info(
                    this.translate.instant('CONS_DUBAI.PROJECT_ALREADY_ASSIGNED', { name: teamLeader?.name })
                );
                return false;
            }
            return true;
        });

        // if (filteredOperators.length === 0) {
        //     this.toastr.info('Nessun operatore selezionato richiede una nuova assegnazione.');
        //     return;
        // }

        const payload = filteredOperators.map(op => ({
            practiceId: project.id,
            WorkerId: op.id
        }));

        console.log('📤 Payload per associazione operatori:', JSON.stringify(payload, null, 2));

        this.consDubaiService.setConsuntivazioneDubaiAssociazionePraticaOperatore(
            this.authService.idToken(),
            this.authService.user().email,
            payload
        ).subscribe({
            next: (response) => {
                if (response?.esito === 'OK') {
                    this.toastr.success(
                        this.translate.instant('CONS_DUBAI.TOAST_SAVE_SUCCESS')
                    );

                    // 🔁 Aggiungi la commessa solo agli operatori non già assegnati
                    filteredOperators.forEach(op => {
                        const teamLeader = this.teamLeaders.find(tl => tl.Id === op.id);
                        if (teamLeader) {
                            teamLeader.projects.push({ ...project });
                        }
                    });

                    this.selectedOperators = [];
                    this.cdr.detectChanges();
                } else {
                    const msg = response?.item?.error || 'Errore sconosciuto';
                    this.toastr.error(
                        this.translate.instant('CONS_DUBAI.TOAST_ERROR_TITLE'),
                        `Errore durante l’associazione: ${msg}`,
                    );
                    console.error('❌ Errore logico (esito KO):', response);
                }
            },
            error: (error) => {
                console.error('❌ Errore HTTP durante l’associazione:', error);
                this.toastr.error('Errore di comunicazione con il server', 'Errore');
            }
        });
    }

    isProjectAssignedToAnyTeamLeader(projectId: number): boolean {
        return this.teamLeaders.some(tl =>
            tl.projects.some(p => p.id === projectId)
        );
    }

    removeProjectFromAllTeamLeaders(project: Project): void {
        const assignedLeaders = this.teamLeaders.filter(tl =>
            tl.projects.some(p => p.id === project.id)
        );

        if (assignedLeaders.length === 0) return;

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: { message: this.translate.instant('CONS_DUBAI.CONFIRM_DELETE_ALL_MESSAGE', { code: project.code }) },
            scrollStrategy: this.scrollStrategies.reposition()
        });

        dialogRef.afterClosed().subscribe(result => {
            if (!result) return;

            const deleteRequests = assignedLeaders.map(tl =>
                this.consDubaiService.deleteConsuntivazioneDubaiAssociazionePraticaOperatore(
                    this.authService.idToken(),
                    this.authService.user().email,
                    project.id,
                    tl.Id
                )
            );

            forkJoin(deleteRequests).subscribe({
                next: (responses) => {
                    assignedLeaders.forEach(tl => {
                        tl.projects = tl.projects.filter(p => p.id !== project.id);
                    });

                    this.toastr.success('Commesse rimosse da tutti gli operatori.', 'Successo');
                    this.cdr.detectChanges();
                },
                error: (err) => {
                    console.error('❌ Errore nella rimozione multipla:', err);
                    this.toastr.error(
                        this.translate.instant('CONS_DUBAI.TOAST_ERROR_TITLE'),
                        'Errore nella rimozione degli operatori.',
                    );
                }
            });
        });
    }

    downloadPdfQrcode(): void {
        const { selectedCountry, selectedSocieta, selectedSedi } = this.lastSearchFilters;

        const email = this.authService.user().email;
        const token = this.authService.idToken();
        const urlFinance = environment.rootApiFinance;

        const url = `${urlFinance}/V1/Output/GetQrCodeSede?account=${encodeURIComponent(email)}&country=${selectedCountry}&societa=${selectedSocieta}&sede=${selectedSedi}&idProfilo=35,36`;

        const headers = new Headers({
            Authorization: `Bearer ${token}`,
            Accept: 'application/pdf'
        });

        // 📁 Costruisci nome del file leggibile
        let filename = 'QrCodeUsers_';
        const parts = [];

        // ✅ Country (già in formato leggibile)
        if (selectedCountry) {
            parts.push(selectedCountry.replace(/,/g, '-'));
        }

        // ✅ Società: da ID a descrizione
        if (selectedSocieta) {
            const societaIds = selectedSocieta.split(',');
            const societaNomi = this.societaList
                .filter(s => societaIds.includes(String(s.ID)))
                .map(s => s.DESCRIZIONE.replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, ''));

            if (societaNomi.length > 0) {
                parts.push(societaNomi.join('-'));
            }
        }

        // ✅ Sedi: da ID a nome sede
        if (selectedSedi) {
            const sediIds = selectedSedi.split(',');
            const sediNomi = this.sediList
                .filter(s => sediIds.includes(String(s.IdSede)))
                .map(s => s.NomeSede.replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, ''));

            if (sediNomi.length > 0) {
                parts.push(sediNomi.join('-'));
            }
        }

        if (parts.length === 0) {
            filename += 'all_operators.pdf';
        } else {
            filename += `${parts.join('_')}.pdf`;
        }

        this.loading = true;

        fetch(url, {
            method: 'GET',
            headers
        })
            .then(response => {
                if (!response.ok) throw new Error('Errore nella risposta del server');
                return response.blob();
            })
            .then(blob => {
                const fileURL = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = fileURL;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(fileURL);
                this.loading = false;
            })
            .catch(err => {
                console.error('❌ Errore durante il download del QR Code:', err);
                this.toastr.error('Errore durante il download del QR Code');
                this.loading = false;
            });
    }




}
